export default "__VITE_ASSET__7d7325b7__"